import { render } from "./StrukSetting_c.vue?vue&type=template&id=eb76c968&scoped=true"
import script from "./StrukSetting_c.vue?vue&type=script&lang=js"
export * from "./StrukSetting_c.vue?vue&type=script&lang=js"

import "./StrukSetting_c.vue?vue&type=style&index=0&id=eb76c968&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eb76c968"

export default script